import { BaseComponent } from '../../base-component';
import { wishlist } from '@otto-ec/nexus-registry/wishlist';
import { push as showSnackbar } from '@otto-ec/otto-components/snackbar/v1';

export class WishlistBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_wishlist-btn';

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) return;

        this.getButtonElement().addEventListener('click', () => this.handleButtonClickEvent());
    }

    public handleButtonClickEvent(): void {
        const variationId = this.getButtonElement().dataset.variationId;
        if (variationId) {
            this.addToWishlist(variationId);
            this.showMessage();
            this.setWishlistButtonToActiveState();
        }
    }

    public addToWishlist(variationId: string): void {
        wishlist.addItem(variationId, true, 'ProductDetailPage').catch(error => {
            Logger.logError('Failed to add item to wishlist:', error);
        });
    }

    private setWishlistButtonToActiveState(): void {
        const iconUseElement = this.getButtonElement();
        if (!iconUseElement) return;

        iconUseElement.setAttribute('icon-type-left', 'wishlist-active');
    }

    private showMessage(): void {
        showSnackbar('Gespeichert!', {
            actions: '<oc-link-v2 variant="inverted"><a href="/wishlist-view/">Merkzettel anzeigen</a></oc-link-v2>',
        });
    }

    private getButtonElement(): HTMLButtonElement {
        return this.getChildElement('.js_pdp_wishlist-btn__button') as HTMLButtonElement;
    }
}
